import React, { useEffect, useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSearchParams } from 'react-router-dom'
import { Alert } from 'react-bootstrap'

import Badge from '../../../components/badge'
import Loading from '../../../components/loading'
import useApi from '../../../hooks/useApi'
import Disbursement from './disbursement'

export default function DashboardCharity() {
  const { t } = useTranslation()
  const [searchParams, setSearchParams] = useSearchParams()

  const { getUserCharityRegistrations } = useApi()

  const [charities, setCharities] = useState([])
  const [loading, setLoading] = useState(false)
  const [stripeMessage, setStripeMessage] = useState(null)

  const fetchData = useCallback(async () => {
    setLoading(true)
    // Get latest user data
    const { data } = await getUserCharityRegistrations()
    if (data) {
      setCharities(data.filter(d => d.verified && d.status === 'Verified'))
    }
    setLoading(false)
  }, [getUserCharityRegistrations])

  useEffect(() => {
    fetchData()
  }, [])

  // Handle return from Stripe onboarding
  useEffect(() => {
    const stripeReturn = searchParams.get('stripe_return')
    const stripeRefresh = searchParams.get('stripe_refresh')

    if (stripeReturn === 'true') {
      setStripeMessage({
        type: 'success',
        text: t('charities.dashboard.stripe.messages.returnSuccess'),
      })
      // Clear the URL params
      searchParams.delete('stripe_return')
      searchParams.delete('charity_id')
      setSearchParams(searchParams)
    } else if (stripeRefresh === 'true') {
      setStripeMessage({
        type: 'warning',
        text: t('charities.dashboard.stripe.messages.sessionExpired'),
      })
      // Clear the URL params
      searchParams.delete('stripe_refresh')
      searchParams.delete('charity_id')
      setSearchParams(searchParams)
    }
  }, [searchParams, setSearchParams, t])

  return (
    <div className="mb-5">
      <Loading show={loading} />
      <div className="container mt-4">
        {stripeMessage && (
          <Alert
            variant={stripeMessage.type}
            onClose={() => setStripeMessage(null)}
            dismissible
            className="mb-3"
          >
            {stripeMessage.text}
          </Alert>
        )}
        <div className="row">
          <h1 className="fs-1 badge-container">
            {t('charities.dashboard.title')}
            <Badge />
          </h1>
          <h6 className="block-description">
            {t('charities.dashboard.description')}&nbsp;
            {/* <a target="_blank" href={t('charities.dashboard.learnMore.link')}>
              {t('charities.dashboard.learnMore.text')}
            </a> */}
          </h6>
        </div>
      </div>
      {charities?.map(charity => (
        <Disbursement charity={charity} key={`charity-${charity.id}`} />
      ))}
    </div>
  )
}
